import axios from "axios";
import moment from "moment";
import toast from "react-hot-toast";
import { takeEvery, put, all, call } from "redux-saga/effects";
import { application } from "../../../../../../redux/store";
import { showResidents, showSmsPreview, showSmsTemplates, filterLoad } from "./slice";
import { ToResidentSmsTypes } from "./types";

function* showResidentSmsHandler({ payload, page }) {
  const response = yield call(() =>
    axios.post(`${application.api}/resident/all?page=${page}`, payload)
  );
  yield put(showResidents(response.data.data.Records));
  yield put(filterLoad(false))
}

function* filterLoadHandler() {
  yield put(filterLoad(true))
}

function* sendSmsPreviewHandler({ payload }) {
  try {
    // all_data, all_resident ve all_landlord değerlerini hazırla
    let all_resident = undefined
    let all_landlord = undefined
    let all_data = undefined
    
    // Eğer payload'da all_data === 1 ise, is_resident filtresine göre ayarla
    // all_data değerini number olarak kontrol et (1 veya "1" veya true olabilir)
    const allDataValue = payload?.all_data === 1 || payload?.all_data === "1" || payload?.all_data === true || payload?.all_data === "true"
    
    if (allDataValue) {
      if (payload?.is_resident === true) {
        // Kiracı seçili + all_data seçili: sadece all_resident = 1
        all_resident = 1
        all_landlord = undefined
        all_data = undefined
      } else if (payload?.is_resident === false) {
        // Ev Sahibi seçili + all_data seçili: sadece all_landlord = 1
        all_landlord = 1
        all_resident = undefined
        all_data = undefined
      } else {
        // Hepsi seçili (is_resident === null) + all_data seçili: sadece all_data = 1
        all_data = 1
        all_resident = undefined
        all_landlord = undefined
      }
    }
    // Eğer all_data !== 1 ise, hiçbiri gönderilmesin (zaten undefined)
    
    const requestBody = {
      future_date: {
        hour: parseInt(payload.hour),
        minute: payload.minute,
        start_date: payload?.date,
      },
      is_future_date: payload?.is_future_date,
      message: payload?.message,
      name: payload?.name ?? null,
      national_id: payload?.national_id,
      not_sending: payload?.not_sending,
      phone: payload?.phone ?? null,
      sending: payload?.sending,
      sms_template_id: payload?.sms_template_id,
    }
    
    // Sadece tanımlı olanları ekle
    if (all_resident !== undefined) {
      requestBody.all_resident = all_resident
    }
    if (all_landlord !== undefined) {
      requestBody.all_landlord = all_landlord
    }
    if (all_data !== undefined) {
      requestBody.all_data = all_data
    }
    
    const response = yield call(() =>
      axios.post(`${application.api}/resident/sms/preview`, requestBody)
    );
    yield put(showSmsPreview(response.data.data));
  } catch (error) {
    toast.error(error.response.data.description);
  }
}
function* sendSmsHandler({ payload }) {
  try {
    const response = yield call(() =>
      axios.post(`${application.api}/resident/sms/send`, {
        all_resident: payload?.all_resident,
        all_landlord: payload?.all_landlord,
        all_data: payload?.all_data,
        future_date: {
          hour: parseInt(payload.hour),
          minute: payload.minute,
          start_date: payload?.date,
        },
        is_future_date: payload?.is_future_date,
        message: payload?.message,
        name: payload?.name ?? null,
        national_id: payload?.national_id,
        is_resident: payload?.is_resident ?? null,
        not_sending: payload?.not_sending,
        phone: payload?.phone ?? null,
        sending: payload?.sending,
        sms_template_id: payload?.sms_template_id,
      })
    );
    if (payload.continually) {
      yield call(() =>
        axios.post(`${application.api}/sms/jobs`, {
          hour: parseInt(payload.hour),
          minute: payload.minute,
          job_type: 0,
          last_date: payload.continually_date,
          message: payload.message,
          name: "test",
          resident_ids: payload.sending,
        })
      );
    }
    toast.success(response.data.description);
  } catch (error) {
    toast.error(error.response.data.description);
  }
}
export function* ToResidentSmsSagas() {
  yield all([
    takeEvery(ToResidentSmsTypes.SHOW_SMS_RESIDENT, showResidentSmsHandler),
    takeEvery(ToResidentSmsTypes.SHOW_SMS_RESIDENT, filterLoadHandler),
    takeEvery(
      ToResidentSmsTypes.SEND_SMS_RESIDENT_PREVIEW,
      sendSmsPreviewHandler
    ),
    takeEvery(ToResidentSmsTypes.SEND_SMS_RESIDENT, sendSmsHandler),
  ]);
}
